<nz-modal nzNoAnimation #visitModalRef nzSize [nzVisible]="isVisitVisible" [nzTitle]=" ('Visit' |
    translate) + ' ' + selectedPatientFullName " (nzOnCancel)=" handleVisitCancel()" nzCancelText="Cancel"
  nzOkText="Save" nzOkType="primary" [nzFooter]="null" class="custom-modal-class">
  <ng-container *nzModalContent>
    <div class="form-row" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutAlign="center center" fxFlex="50">
        <div class="visit-icons" fxLayout="column" [ngClass]="{'active-option':isNewSelected}"
          (click)="selectNewVisit()">
          <div class="visit-label">{{"Create New Visit" | translate}}</div>
          <i nz-icon [nzType]="isNewSelected ? 'icons:plus-color' : 'icons:plus'" class="visit-icon"></i>
        </div>
      </div>
      <div fxLayout="column" fxLayoutAlign="center center" fxFlex="50">
        <div class="visit-icons" fxLayout="column" [ngClass]="{'active-option':!isNewSelected}"
          (click)="selectDraftVisit()">
          <div class="visit-label">{{"Select an existing Draft Visit" | translate}}</div>
          <i nz-icon [nzType]="!isNewSelected ? 'icons:archive-color' : 'icons:archive'"
          class="visit-icon"></i>
        </div>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center">
      <div fxLayout="column" fxLayoutAlign="center start" fxFlex="50">
        <nz-select class="draft-select" nzShowSearch nzAllowClear
          [nzPlaceHolder]="'Select an existing Draft Visit' | translate" [nzLoading]="isVisitLoading"
          style="width: 100%" [visible]="!isNewSelected" [(ngModel)]="draftVisit">
          @for (visit of existingVisits; track visit) {
            <nz-option
              [nzLabel]="formatDate(visit.date?.toString()) + ' ' + (visit?.notes ? ' | ' + visit.notes : '') "
            [nzValue]="visit.id"></nz-option>
          }
        </nz-select>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="end" class="footer">
      <button nz-button nzPrimary class="save-btn" type="submit" [nzLoading]="isVisitLoading"
        [disabled]="isVisitLoading || (!isNewSelected && !draftVisit)" (click)="handleVisitSubmit()">
        {{ "Visit" | translate }}
      </button>
      <button nz-button nzDanger class="cancel-btn" type="button" (click)="handleVisitCancel()"
        [disabled]="isVisitLoading">
        {{ "Cancel" | translate }}
      </button>
    </div>
  </ng-container>
  <ng-template>
    <button type="submit">{{ "Save" | translate }}</button>
  </ng-template>
</nz-modal>